import React from "react";
import {useNavigate} from "react-router-dom";
import {getLicenseListByAsset} from "../../../../api/asset/LicenseService";
import {ASSET_LICENSE_HEADER} from "../../../../components/table/header/Headers";
import useRequestData from "../../../../hooks/useRequestData";
import DetailLinkedListView from "../../../../components/detailLayout/DetailLinkedListView";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../components/pageTabs/pageTabsStorage";

function AssetLicense({id}) {
    const navigate = useNavigate();
    const {newData, dataHook} = useRequestData((conditions, pageable) => {
        return getLicenseListByAsset(id, pageable);
    }, {});

    const handleRowClick = (row) => {
        const rowId = row?.id;
        if (rowId == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "라이선스 상세"),
            url: `/license/${rowId}`,
        });
    };

    return (
        <DetailLinkedListView
            headerDefinition={ASSET_LICENSE_HEADER}
            settingKey="asset_license"
            newData={newData}
            onPageChange={dataHook.handleGridPageChange}
            onRowClick={handleRowClick}
        />
    );
}

export default AssetLicense;
